import { EmojiRatingScalePage } from '~/shared/components/EmojiRatingScalePage'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'Do you agree with this statement?'

const RATING_OPTIONS = [
  { key: 'stronglyDisagree', emoji: '👎', fontSize: 24 },
  { key: 'disagree', emoji: '👎', fontSize: 16 },
  { key: 'neutral', emoji: '🤔', fontSize: 16 },
  { key: 'agree', emoji: '👍', fontSize: 16 },
  { key: 'stronglyAgree', emoji: '👍', fontSize: 24 },
] as const

const FriendlyPush = (props: TPageProps) => (
  <EmojiRatingScalePage
    {...props}
    ns="history"
    question={QUESTION}
    titleI18nKey="onboarding.historyFriendlyPush.title"
    statementI18nKey="onboarding.historyFriendlyPush.statement"
    options={RATING_OPTIONS}
  />
)

export default FriendlyPush
